import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import { Colors, fonts } from '../style/GlobalStyles';

const NavbarContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 900;
  width: 100%;
  padding: 1rem 0;
  display: flex;
  justify-content: center;
  background: ${Colors.paper};
`;

const NavBar = styled.nav`
  width: 92%;
  max-width: 1320px;
  border-radius: 999px;
  border: 1.5px solid ${Colors.ink};
  background: ${Colors.paper};
  display: flex;
  align-items: center;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  box-sizing: border-box;
  gap: 0.5rem;
`;

const Logo = styled.div`
  font-family: ${fonts.display};
  font-size: 1.35rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${Colors.ink};
  margin-right: 2.5rem;
  cursor: pointer;
`;

const NavLinks = styled.ul`
  display: flex;
  gap: 2.5rem;
  flex: 1;
  margin: 0;
  padding: 0;

  li {
    list-style: none;
  }

  a {
    font-family: ${fonts.body};
    text-decoration: none;
    color: ${Colors.ink};
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover,
    &.active {
      opacity: 0.55;
    }
  }

  @media (max-width: 930px) {
    display: none;
  }
`;

const NavButton = styled.button`
  font-family: ${fonts.body};
  background: ${Colors.ink};
  color: ${Colors.paper};
  font-weight: 600;
  padding: 0.85rem 2rem;
  border: none;
  border-radius: 999px;
  font-size: 1rem;
  cursor: pointer;
  margin-left: auto;
  transition: background 0.2s, color 0.2s;

  a {
    text-decoration: none;
    color: inherit;
  }

  &:hover {
    background: ${Colors.lime};
    color: ${Colors.ink};
  }

  @media (max-width: 930px) {
    display: none;
  }
`;

const Hamburger = styled.div`
  display: none;
  font-size: 1.6rem;
  color: ${Colors.ink};
  cursor: pointer;
  margin-left: auto;
  padding: 0.4rem 1rem;

  @media (max-width: 930px) {
    display: block;
  }
`;

const DropdownMenu = styled.div`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  position: absolute;
  top: 76px;
  right: 4%;
  min-width: 260px;
  background: ${Colors.ink};
  border-radius: 24px;
  overflow: hidden;
  z-index: 999;

  ul {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding: 1.5rem;
    margin: 0;
  }

  li {
    list-style: none;
  }

  a {
    display: block;
    text-decoration: none;
    color: ${Colors.paper};
    font-family: ${fonts.body};
    font-size: 1.05rem;
    font-weight: 500;
    padding: 0.6rem 0;
    cursor: pointer;
    &:hover {
      color: ${Colors.lime};
    }
  }
`;

const links = [
  { to: 'home', label: 'Home' },
  { to: 'about', label: 'About' },
  { to: 'work', label: 'Work' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((v) => !v);

  return (
    <NavbarContainer>
      <NavBar>
        <Logo>
          <Link to="home" smooth spy>
            Santiago<span style={{ color: Colors.lavender }}>.</span>
          </Link>
        </Logo>
        <NavLinks>
          {links.map((l) => (
            <li key={l.to}>
              <Link activeClass="active" smooth spy to={l.to}>
                {l.label}
              </Link>
            </li>
          ))}
        </NavLinks>
        <NavButton>
          <Link activeClass="active" smooth spy to="contact">
            Contact
          </Link>
        </NavButton>
        <Hamburger onClick={toggle}>
          <i className={open ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'} />
        </Hamburger>
      </NavBar>
      <DropdownMenu $open={open}>
        <ul>
          {links.map((l) => (
            <li key={l.to}>
              <Link activeClass="active" smooth spy to={l.to} onClick={toggle}>
                {l.label}
              </Link>
            </li>
          ))}
          <li>
            <Link activeClass="active" smooth spy to="contact" onClick={toggle}>
              Contact
            </Link>
          </li>
        </ul>
      </DropdownMenu>
    </NavbarContainer>
  );
};

export default Navbar;
